import { Entity } from 'engine/Entity';
import { ColliderFacet, ColliderType } from 'engine/facets/ColliderFacet';
import { Facet } from 'engine/facets/Facet';
import { StaticSpriteFacet } from 'engine/facets/StaticSpriteFacet';
import { create } from 'engine/lib/create';
import times from 'lodash/times';
import { FenceFrontLeftSprite, FencePostSprite, FenceRightSprite, FenceTopSprite } from './FenceSprite';

export class FenceFrontLeftEntity extends Entity {
  createFacets() {
    return [
      create(StaticSpriteFacet, { frame: FenceFrontLeftSprite, offset: [0, -380] }),
      create(ColliderFacet, { type: ColliderType.Box, offset: [0, -380], size: [2250, 380] }),
    ];
  }
}

export class FenceLeftEntity extends Entity {
  createFacets() {
    const sectionSize = 615;
    const sectionCount = 4;
    const facets: Facet[] = [
      create(ColliderFacet, {
        type: ColliderType.Box,
        size: [60, sectionSize * (sectionCount + 1)],
        offset: [-25, -sectionSize * (sectionCount + 1)],
      }),
    ];
    times(sectionCount, i => {
      const y = (i + 1) * sectionSize;
      facets.push(
        create(StaticSpriteFacet, { frame: FenceTopSprite, offset: [12, -380 - y + 40] }),
        create(StaticSpriteFacet, { frame: FencePostSprite, offset: [0, -380 - y] }),
      );
    });
    return facets.reverse();
  }
}

export class FenceRightEntity extends Entity {
  createFacets() {
    return [
      create(StaticSpriteFacet, { frame: FenceRightSprite, offset: [0, -380] }),
      create(ColliderFacet, { type: ColliderType.Box, size: [1510, 380], offset: [0, -380] }),
    ];
  }
}
